import { useChat } from "@/context/ChatContext";
import { useLang } from "@/i18n/LanguageContext";
import { MessageCircle, Sparkles } from "lucide-react";
import { motion } from "framer-motion";

export default function ChatLauncher() {
  const { open, openChat, messages } = useChat();
  const { t } = useLang();

  if (open) return null;

  const hasMessages = messages.length > 0;

  return (
    <motion.button
      initial={{ opacity: 0, scale: 0.8, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 0.4, type: "spring", stiffness: 240, damping: 22 }}
      onClick={() => openChat()}
      className="group fixed bottom-5 right-5 z-30 inline-flex items-center gap-2.5 rounded-full bg-zinc-950 px-5 py-3.5 text-sm font-semibold text-white shadow-[0_24px_60px_-20px_rgba(81,75,186,0.65)] transition-transform duration-200 hover:scale-[1.03] sm:bottom-7 sm:right-7"
      data-testid="chat-launcher"
      aria-label={t.chat.launcherLabel}
    >
      <span className="relative flex h-8 w-8 items-center justify-center rounded-full bg-[color:var(--sentinel)]">
        <MessageCircle className="h-4 w-4" strokeWidth={2.5} />
        {!hasMessages && (
          <span className="absolute -right-0.5 -top-0.5 inline-flex h-3 w-3 items-center justify-center rounded-full bg-[color:var(--sentinel-accent)]">
            <Sparkles className="h-2 w-2 text-[color:var(--sentinel-darker)]" />
          </span>
        )}
      </span>
      <span className="hidden sm:inline">{t.chat.launcherLabel}</span>
      <span className="sm:hidden">Andy</span>
    </motion.button>
  );
}
